import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {TranslateModule} from '@ngx-translate/core';
import {NgxImageCompressService} from 'ngx-image-compress';
import {effects, quoteMetaReducers, reducers} from './store';

@NgModule({
    declarations: [],
    providers: [NgxImageCompressService,

    ],
    exports: [RouterModule],
    imports: [
        CommonModule,
        RouterModule,
        StoreModule.forFeature('core', reducers,
            {metaReducers : quoteMetaReducers}
        ),
        EffectsModule.forFeature(effects),
        FormsModule,
        TranslateModule,
    ]
})
export class CoreModule {
}
